import { render, staticRenderFns } from "./id-photo-editor.vue?vue&type=template&id=564500cb&scoped=true&"
import script from "./id-photo-editor.vue?vue&type=script&lang=js&"
export * from "./id-photo-editor.vue?vue&type=script&lang=js&"
import style0 from "./id-photo-editor.vue?vue&type=style&index=0&id=564500cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564500cb",
  null
  
)

export default component.exports